import { setupHelpers } from './helpers.js'
import { setupState } from './state.js'
import { registerServiceWorkers } from './serviceworker.js'
import { setupOnlineStatus } from './onlinestatus.js'
import { makeInstallable } from './installable.js'
import { lockOrientation } from './orientation.js'

import Vue from 'vue'
import Scanner from './Scanner.vue'
import rfidService from './rfidService.js'

setupHelpers()
setupState()
registerServiceWorkers()
setupOnlineStatus()
lockOrientation()

const scanner = window.scanner
Vue.prototype.$scanner = window.scanner

scanner.debugging = false
scanner.registered = false

scanner.api_server = process.env.VUE_APP_API_SERVER
scanner.enable_square = Boolean(process.env.VUE_APP_SQUARE_ENABLED && process.env.VUE_APP_SQUARE_ENABLED.toLowerCase() === "true")

window.resizeTo(320, 600)
window.makeInstallable = makeInstallable

// note: this app receives realtime connection status from the device or browser, but the polling is to check if it can connect to our servers not just if it is online and is now a secondary check hence the 30sec interval.  realtime connection switching happens on the fly.
// window.connection.check_interval = 30 // in seconds
// Vue.prototype.$scanner_heartbeat = setInterval(window.connection.checkConnection, 1000 * window.connection.check_interval);

scanner.app = new Vue({ render: h => h(Scanner), provide: {rfidService} }).$mount('#scanner')
